import { theme } from '@/styles';
import { Icongraphy, Text } from '@design-system/pc';
import React from 'react';
import styled from 'styled-components';

interface BtnMapRefreshprops {
  onClick: () => void;
}

const BtnMapRefresh = ({ onClick, ...props }: BtnMapRefreshprops) => {
  return (
    <Container onClick={onClick} {...props}>
      <Icongraphy variant="ic_refresh" size={24} resize />
      <Text
        color={theme.colors.accent_colors.primary.default}
        variant="label_lg_b"
      >
        현 지도에서 검색
      </Text>
    </Container>
  );
};

export default BtnMapRefresh;

const Container = styled.div`
  width: 182px;
  height: 48px;
  border-radius: 24px;
  gap: 4px;
  padding: 12px 24px;
  display: flex;

  align-items: center;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  background-color: ${({ theme }) => theme.colors.natural_color.white};
  position: absolute;
  bottom: 40px;
  z-index: 9999;
  left: 50%;
  cursor: pointer;
  transform: translateX(-50%);
`;
